module.exports = __webpack_public_path__ + "img/meet.45017c46.svg";